import Report from "../../../screens/private/report/inbound-outbound";
export default Report;
